(function () {
  'use strict';
  if (window.gmSingleVariantMinimumInitialized) return;
  window.gmSingleVariantMinimumInitialized = true;

  var MINIMUM_PROPERTY = '_gm_minimum_quantity';
  var CART_SYNCING = false;
  var PRODUCT_CACHE = {};
  var PAGE_LOCALE = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var UK_ENGLISH = PAGE_LOCALE === 'en' && /(^|\.)gummymolds\.uk$/i.test(window.location.hostname);
  var AU_ENGLISH = PAGE_LOCALE === 'en' && /^\/en-au(?:\/|$)/i.test(window.location.pathname);

  var COPY = {
    en: {
      minimum: 'Minimum {min} molds',
      gummyBackorder: 'Ready stock is sold out. This mold remains available made to order with a 10-mold minimum.',
      chocolateBackorder: 'Ready stock is sold out. This mold remains available made to order with a {min}-mold minimum.',
      bulkMinimum: 'This mold is made to order with a {min}-mold minimum.',
      gummyOverage: '{stock} molds are in stock and ship from California in 1–2 business days. The remaining {remaining} molds will be made to order and typically require 1–2 weeks before shipping.',
      chocolateOverage: '{stock} molds are available from ready stock. The remaining {remaining} molds will be made to order. Contact us for current production and shipping timing.',
      partialBadge: 'Includes made-to-order molds',
      prototypeGummy: 'Purchase Prototype Deposit',
      prototypeChocolate: 'Purchase Prototype Package',
      packagePrefix: 'Purchase ',
      packageSuffix: '-Mold Package'
    },
    es: {
      minimum: 'Mínimo {min} moldes',
      gummyBackorder: 'El inventario listo para enviar está agotado. Este molde sigue disponible bajo pedido con un mínimo de 10 moldes.',
      chocolateBackorder: 'El inventario listo para enviar está agotado. Este molde sigue disponible bajo pedido con un mínimo de {min} moldes.',
      bulkMinimum: 'Este molde se fabrica bajo pedido con un mínimo de {min} moldes.',
      gummyOverage: '{stock} moldes están en stock y se envían desde California en 1–2 días laborables. Los {remaining} moldes restantes se fabricarán bajo pedido y normalmente requieren 1–2 semanas antes del envío.',
      chocolateOverage: '{stock} moldes están disponibles en inventario. Los {remaining} moldes restantes se fabricarán bajo pedido. Contáctanos para conocer el plazo actual de producción y envío.',
      partialBadge: 'Incluye moldes fabricados bajo pedido',
      prototypeGummy: 'Pagar depósito de prototipo',
      prototypeChocolate: 'Comprar paquete de prototipo',
      packagePrefix: 'Comprar paquete de ',
      packageSuffix: ' moldes'
    },
    de: {
      minimum: 'Mindestens {min} Formen',
      gummyBackorder: 'Der sofort verfügbare Bestand ist ausverkauft. Diese Form bleibt als Auftragsfertigung mit einer Mindestmenge von 10 Formen verfügbar.',
      chocolateBackorder: 'Der sofort verfügbare Bestand ist ausverkauft. Diese Form bleibt als Auftragsfertigung mit einer Mindestmenge von {min} Formen verfügbar.',
      bulkMinimum: 'Diese Form wird auf Bestellung mit einer Mindestmenge von {min} Formen gefertigt.',
      gummyOverage: '{stock} Formen sind auf Lager und werden innerhalb von 1–2 Werktagen aus Kalifornien versendet. Die verbleibenden {remaining} Formen werden auf Bestellung gefertigt und benötigen in der Regel 1–2 Wochen bis zum Versand.',
      chocolateOverage: '{stock} Formen sind sofort verfügbar. Die verbleibenden {remaining} Formen werden auf Bestellung gefertigt. Kontaktieren Sie uns für aktuelle Produktions- und Versandzeiten.',
      partialBadge: 'Enthält Formen aus Auftragsfertigung',
      prototypeGummy: 'Prototyp-Anzahlung leisten',
      prototypeChocolate: 'Prototyp-Paket kaufen',
      packagePrefix: 'Paket mit ',
      packageSuffix: ' Formen kaufen'
    },
    fr: {
      minimum: 'Minimum {min} moules',
      gummyBackorder: 'Le stock prêt à expédier est épuisé. Ce moule reste disponible sur commande avec un minimum de 10 moules.',
      chocolateBackorder: 'Le stock prêt à expédier est épuisé. Ce moule reste disponible sur commande avec un minimum de {min} moules.',
      bulkMinimum: 'Ce moule est fabriqué sur commande avec un minimum de {min} moules.',
      gummyOverage: '{stock} moules sont en stock et sont expédiés de Californie sous 1 à 2 jours ouvrés. Les {remaining} moules restants seront fabriqués sur commande et nécessitent généralement 1–2 semaines avant expédition.',
      chocolateOverage: '{stock} moules sont disponibles en stock. Les {remaining} moules restants seront fabriqués sur commande. Contactez-nous pour connaître les délais actuels de production et d’expédition.',
      partialBadge: 'Comprend des moules fabriqués sur commande',
      prototypeGummy: 'Verser l’acompte prototype',
      prototypeChocolate: 'Acheter le pack prototype',
      packagePrefix: 'Acheter le pack de ',
      packageSuffix: ' moules'
    },
    it: {
      minimum: 'Minimo {min} stampi',
      gummyBackorder: 'Le scorte pronte alla spedizione sono esaurite. Questo stampo resta disponibile su ordinazione con un minimo di 10 stampi.',
      chocolateBackorder: 'Le scorte pronte alla spedizione sono esaurite. Questo stampo resta disponibile su ordinazione con un minimo di {min} stampi.',
      bulkMinimum: 'Questo stampo viene prodotto su ordinazione con un minimo di {min} stampi.',
      gummyOverage: '{stock} stampi sono disponibili e vengono spediti dalla California in 1–2 giorni lavorativi. I restanti {remaining} stampi saranno prodotti su ordinazione e normalmente richiedono 1–2 settimane prima della spedizione.',
      chocolateOverage: '{stock} stampi sono disponibili in pronta consegna. I restanti {remaining} stampi saranno prodotti su ordinazione. Contattaci per i tempi attuali di produzione e spedizione.',
      partialBadge: 'Include stampi prodotti su ordinazione',
      prototypeGummy: 'Versa l’acconto per il prototipo',
      prototypeChocolate: 'Acquista pacchetto prototipo',
      packagePrefix: 'Acquista pacchetto da ',
      packageSuffix: ' stampi'
    },
    ja: {
      minimum: '最低 {min} 個のモールド',
      gummyBackorder: '即納在庫は完売しました。このモールドは最低10個から受注生産でご注文いただけます。',
      chocolateBackorder: '即納在庫は完売しました。このモールドは最低{min}個から受注生産でご注文いただけます。',
      bulkMinimum: 'このモールドは最低{min}個から受注生産となります。',
      gummyOverage: '{stock}個は在庫があり、カリフォルニアから1〜2営業日で発送されます。残りの{remaining}個は受注生産となり、発送まで通常1〜2週間かかります。',
      chocolateOverage: '{stock}個は即納在庫があります。残りの{remaining}個は受注生産となります。現在の製造・発送時期についてはお問い合わせください。',
      partialBadge: '受注生産分を含みます',
      prototypeGummy: 'プロトタイプのデポジットを支払う',
      prototypeChocolate: 'プロトタイプパッケージを購入',
      packagePrefix: '',
      packageSuffix: '個モールドパッケージを購入'
    },
    nl: {
      minimum: 'Minimaal {min} mallen',
      gummyBackorder: 'De direct beschikbare voorraad is uitverkocht. Deze mal blijft op bestelling verkrijgbaar met een minimum van 10 mallen.',
      chocolateBackorder: 'De direct beschikbare voorraad is uitverkocht. Deze mal blijft op bestelling verkrijgbaar met een minimum van {min} mallen.',
      bulkMinimum: 'Deze mal wordt op bestelling gemaakt met een minimum van {min} mallen.',
      gummyOverage: '{stock} mallen zijn op voorraad en worden binnen 1–2 werkdagen vanuit Californië verzonden. De resterende {remaining} mallen worden op bestelling gemaakt en hebben doorgaans 1–2 weken nodig voor verzending.',
      chocolateOverage: '{stock} mallen zijn direct uit voorraad beschikbaar. De resterende {remaining} mallen worden op bestelling gemaakt. Neem contact met ons op voor de actuele productie- en verzendtijd.',
      partialBadge: 'Bevat op bestelling gemaakte mallen',
      prototypeGummy: 'Prototype-aanbetaling betalen',
      prototypeChocolate: 'Prototypepakket kopen',
      packagePrefix: 'Pakket met ',
      packageSuffix: ' mallen kopen'
    },
    pl: {
      minimum: 'Minimum {min} form',
      gummyBackorder: 'Gotowy zapas jest wyprzedany. Ta forma pozostaje dostępna na zamówienie przy minimum 10 form.',
      chocolateBackorder: 'Gotowy zapas jest wyprzedany. Ta forma pozostaje dostępna na zamówienie przy minimum {min} form.',
      bulkMinimum: 'Ta forma jest wykonywana na zamówienie przy minimum {min} form.',
      gummyOverage: '{stock} form jest w magazynie i zostanie wysłanych z Kalifornii w ciągu 1–2 dni roboczych. Pozostałe {remaining} form zostanie wykonanych na zamówienie i zwykle wymaga 1–2 tygodni przed wysyłką.',
      chocolateOverage: '{stock} form jest dostępnych z gotowego zapasu. Pozostałe {remaining} form zostanie wykonanych na zamówienie. Skontaktuj się z nami, aby uzyskać aktualny termin produkcji i wysyłki.',
      partialBadge: 'Zawiera formy wykonywane na zamówienie',
      prototypeGummy: 'Zapłać depozyt za prototyp',
      prototypeChocolate: 'Kup pakiet prototypowy',
      packagePrefix: 'Kup pakiet ',
      packageSuffix: ' form'
    },
    ro: {
      minimum: 'Minimum {min} matrițe',
      gummyBackorder: 'Stocul gata de livrare este epuizat. Această matriță rămâne disponibilă la comandă cu un minim de 10 matrițe.',
      chocolateBackorder: 'Stocul gata de livrare este epuizat. Această matriță rămâne disponibilă la comandă cu un minim de {min} matrițe.',
      bulkMinimum: 'Această matriță este realizată la comandă cu un minim de {min} matrițe.',
      gummyOverage: '{stock} matrițe sunt în stoc și se expediază din California în 1–2 zile lucrătoare. Celelalte {remaining} matrițe vor fi realizate la comandă și necesită de obicei 1–2 săptămâni înainte de expediere.',
      chocolateOverage: '{stock} matrițe sunt disponibile din stoc. Celelalte {remaining} matrițe vor fi realizate la comandă. Contactează-ne pentru termenul actual de producție și expediere.',
      partialBadge: 'Include matrițe realizate la comandă',
      prototypeGummy: 'Plătește avansul pentru prototip',
      prototypeChocolate: 'Cumpără pachetul prototip',
      packagePrefix: 'Cumpără pachetul de ',
      packageSuffix: ' matrițe'
    },
    cs: {
      minimum: 'Minimum {min} forem',
      gummyBackorder: 'Skladové zásoby jsou vyprodané. Tato forma zůstává dostupná na objednávku s minimem 10 forem.',
      chocolateBackorder: 'Skladové zásoby jsou vyprodané. Tato forma zůstává dostupná na objednávku s minimem {min} forem.',
      bulkMinimum: 'Tato forma se vyrábí na objednávku s minimem {min} forem.',
      gummyOverage: '{stock} forem je skladem a odesílá se z Kalifornie do 1–2 pracovních dnů. Zbývajících {remaining} forem bude vyrobeno na objednávku a obvykle vyžaduje 1–2 týdny před odesláním.',
      chocolateOverage: '{stock} forem je dostupných skladem. Zbývajících {remaining} forem bude vyrobeno na objednávku. Pro aktuální termín výroby a expedice nás kontaktujte.',
      partialBadge: 'Obsahuje formy vyráběné na objednávku',
      prototypeGummy: 'Zaplatit zálohu za prototyp',
      prototypeChocolate: 'Koupit prototypový balíček',
      packagePrefix: 'Koupit balíček ',
      packageSuffix: ' forem'
    },
    sk: {
      minimum: 'Minimum {min} foriem',
      gummyBackorder: 'Skladové zásoby sú vypredané. Táto forma zostáva dostupná na objednávku s minimom 10 foriem.',
      chocolateBackorder: 'Skladové zásoby sú vypredané. Táto forma zostáva dostupná na objednávku s minimom {min} foriem.',
      bulkMinimum: 'Táto forma sa vyrába na objednávku s minimom {min} foriem.',
      gummyOverage: '{stock} foriem je skladom a odosiela sa z Kalifornie do 1–2 pracovných dní. Zvyšných {remaining} foriem bude vyrobených na objednávku a zvyčajne vyžaduje 1–2 týždne pred odoslaním.',
      chocolateOverage: '{stock} foriem je dostupných skladom. Zvyšných {remaining} foriem bude vyrobených na objednávku. Pre aktuálny termín výroby a odoslania nás kontaktujte.',
      partialBadge: 'Obsahuje formy vyrábané na objednávku',
      prototypeGummy: 'Zaplatiť zálohu za prototyp',
      prototypeChocolate: 'Kúpiť prototypový balík',
      packagePrefix: 'Kúpiť balík ',
      packageSuffix: ' foriem'
    },
    sv: {
      minimum: 'Minst {min} formar',
      gummyBackorder: 'Lagervaran är slutsåld. Den här formen kan fortfarande beställas med ett minimiantal på 10 formar.',
      chocolateBackorder: 'Lagervaran är slutsåld. Den här formen kan fortfarande beställas med ett minimiantal på {min} formar.',
      bulkMinimum: 'Den här formen tillverkas på beställning med ett minimiantal på {min} formar.',
      gummyOverage: '{stock} formar finns i lager och skickas från Kalifornien inom 1–2 arbetsdagar. De återstående {remaining} formarna tillverkas på beställning och behöver normalt 1–2 veckor före leverans.',
      chocolateOverage: '{stock} formar finns i lager. De återstående {remaining} formarna tillverkas på beställning. Kontakta oss för aktuell produktions- och leveranstid.',
      partialBadge: 'Inkluderar formar som tillverkas på beställning',
      prototypeGummy: 'Betala prototypdeposition',
      prototypeChocolate: 'Köp prototyppaket',
      packagePrefix: 'Köp paket med ',
      packageSuffix: ' formar'
    }
  };

  function copy() {
    var strings = COPY[PAGE_LOCALE] || COPY.en;
    if (!(UK_ENGLISH || AU_ENGLISH) || strings !== COPY.en) return strings;
    if (!COPY.enGB) {
      COPY.enGB = {};
      Object.keys(COPY.en).forEach(function (key) {
        var value = COPY.en[key];
        COPY.enGB[key] = typeof value === 'string'
          ? value.replace(/\bmolds\b/g, 'moulds').replace(/\bmold\b/g, 'mould').replace(/\bMold\b/g, 'Mould')
          : value;
      });
    }
    return COPY.enGB;
  }
  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (_, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : '';
    });
  }
  function toInteger(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : fallback;
  }
  function formatQuantity(value) {
    var q = Math.max(0, toInteger(value, 0));
    try { return q.toLocaleString(document.documentElement.lang || undefined); }
    catch (e) { return String(q); }
  }
  function configuredMinimum(selector) { return Math.max(1, toInteger(selector && selector.getAttribute('data-gm-configured-minimum'), 10)); }
  function productKind(selector) { return String(selector && selector.getAttribute('data-gm-product-kind') || 'gummy').toLowerCase() === 'chocolate' ? 'chocolate' : 'gummy'; }

  function getState(input, requestedQuantity) {
    var selector = input && input.closest('[data-gm-mold-selector]');
    var form = input && input.closest('form[data-product-form]');
    var kind = productKind(selector);
    var readyStock = Boolean(selector && selector.getAttribute('data-gm-ready-stock') === 'true');
    var bulkSingleUnit = Boolean(selector && selector.getAttribute('data-gm-bulk-single-unit') === 'true');
    var inventory = Math.max(0, toInteger(input && input.getAttribute('data-gm-available-inventory'), 0));
    var tracked = Boolean(input && input.getAttribute('data-gm-inventory-tracked') === 'true');
    var policy = String(input && input.getAttribute('data-gm-inventory-policy') || '').toLowerCase();
    var available = Boolean(input && input.getAttribute('data-gm-variant-available') === 'true');
    var requested = Math.max(0, toInteger(requestedQuantity, 1));
    var backorder = readyStock && available && tracked && policy === 'continue' && inventory <= 0;
    var bulkMinimum = bulkSingleUnit && available;
    var soldOut = !available && !backorder;
    var minimum = soldOut ? 0 : (backorder ? (kind === 'chocolate' ? configuredMinimum(selector) : 10) : (bulkMinimum ? configuredMinimum(selector) : 1));
    var maximum = soldOut ? 0 : tracked && policy !== 'continue' ? inventory : null;
    var overage = readyStock && available && tracked && policy === 'continue' && inventory > 0 && requested > inventory;
    return { available: available, backorder: backorder, bulkMinimum: bulkMinimum, form: form, inventory: inventory, kind: kind, maximum: maximum, minimum: minimum, overage: overage, readyStock: readyStock, requested: requested, selector: selector, soldOut: soldOut };
  }

  function updateDisplay(state) {
    if (!state.selector) return;
    var strings = copy();
    var badge = state.selector.querySelector('[data-gm-quantity-badge]');
    var notice = state.selector.querySelector('[data-gm-quantity-notice]');
    var badgeText = '';
    var noticeText = '';
    var values = {
      min: formatQuantity(state.minimum),
      stock: formatQuantity(state.inventory),
      remaining: formatQuantity(Math.max(0, state.requested - state.inventory))
    };

    if (state.backorder) {
      badgeText = fill(strings.minimum, values);
      noticeText = fill(state.kind === 'chocolate' ? strings.chocolateBackorder : strings.gummyBackorder, values);
    } else if (state.bulkMinimum) {
      badgeText = fill(strings.minimum, values);
      noticeText = fill(strings.bulkMinimum, values);
    } else if (state.overage) {
      badgeText = strings.partialBadge;
      noticeText = fill(state.kind === 'chocolate' ? strings.chocolateOverage : strings.gummyOverage, values);
    }

    if (badge) {
      badge.textContent = badgeText;
      badge.hidden = !badgeText;
    }
    if (notice) {
      notice.textContent = noticeText;
      notice.hidden = !noticeText;
    }

    // Do not rewrite .gm-purchase-status here. That status is server-rendered by Liquid
    // in the active storefront language and remains the source of truth for visible copy.
  }

  function syncProperty(state) {
    if (!state.form) return;
    var field = state.form.querySelector('input[name="properties[' + MINIMUM_PROPERTY + ']"]');
    var required = state.backorder || state.bulkMinimum;
    if (required && !field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[' + MINIMUM_PROPERTY + ']';
      state.form.appendChild(field);
    }
    if (required && field) field.value = String(state.minimum);
    if (!required && field) field.remove();
  }

  function applyProductState(input, resetValue, clampValue) {
    if (!input) return null;
    var current = toInteger(input.value, 1);
    var state = getState(input, current);
    input.min = String(state.minimum);
    if (state.maximum === null) input.removeAttribute('max'); else input.max = String(state.maximum);
    if (resetValue) current = state.backorder || state.bulkMinimum ? state.minimum : state.soldOut ? 0 : 1;
    if (clampValue) {
      current = Math.max(state.minimum, toInteger(current, state.minimum));
      if (state.maximum !== null) current = Math.min(state.maximum, current);
    }
    input.value = String(current);
    state = getState(input, current);
    input.setAttribute('data-gm-minimum', String(state.minimum));
    updateDisplay(state);
    syncProperty(state);
    var minus = state.selector && state.selector.querySelector('[data-quantity-decrement]');
    var plus = state.selector && state.selector.querySelector('[data-quantity-increment]');
    if (minus) minus.disabled = state.soldOut || current <= state.minimum;
    if (plus) plus.disabled = state.soldOut || (state.maximum !== null && current >= state.maximum);
    return state;
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags.map(String);
    return String(tags || '').split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
  }
  function minimumFromTags(tags) {
    var minimum = 10;
    normalizeTags(tags).forEach(function (tag) {
      var match = String(tag).match(/^(\d+)\s+Mold Minimum$/i);
      if (match && Number(match[1]) > 0) minimum = Number(match[1]);
    });
    return minimum;
  }
  function productJsonPath(item) {
    var url = String(item && (item.url || item.product_url) || '').split('?')[0];
    if (!url) return '';
    return url.replace(/\.js$/, '') + '.js';
  }
  function fetchProduct(path) {
    if (!path) return Promise.resolve(null);
    if (PRODUCT_CACHE[path]) return PRODUCT_CACHE[path];
    PRODUCT_CACHE[path] = fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return PRODUCT_CACHE[path];
  }
  function itemMinimum(item) {
    var properties = item && item.properties ? item.properties : {};
    var explicit = Math.max(0, toInteger(properties[MINIMUM_PROPERTY], 0));
    if (explicit) return Promise.resolve(explicit);
    return fetchProduct(productJsonPath(item)).then(function (product) {
      if (!product) return 0;
      var tags = normalizeTags(product.tags);
      var chocolate = tags.indexOf('ready-to-ship-chocolate-mold') !== -1 || tags.indexOf('chocolate-bulk-made-to-order') !== -1;
      var readyTag = chocolate ? 'ready-to-ship-chocolate-mold' : 'ready-to-ship-mold';
      var bulkTag = chocolate ? 'chocolate-bulk-made-to-order' : 'bulk-made-to-order';
      var ready = tags.indexOf(readyTag) !== -1;
      var bulk = tags.indexOf(bulkTag) !== -1;
      var configured = minimumFromTags(tags);
      if (bulk && !ready) return configured;
      if (!ready) return 0;
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.find(function (candidate) { return String(candidate.id) === String(item.variant_id); });
      if (!variant) return 0;
      var tracked = Boolean(variant.inventory_management);
      var continues = String(variant.inventory_policy || '').toLowerCase() === 'continue';
      var inventory = toInteger(variant.inventory_quantity, 0);
      if (!(tracked && continues && inventory <= 0 && variant.available !== false)) return 0;
      return chocolate ? configured : 10;
    });
  }

  function cartUrl(suffix) {
    var base = window.theme && window.theme.routes_cart_url ? window.theme.routes_cart_url : '/cart';
    return base.replace(/\/$/, '') + suffix;
  }
  function synchronizeCart() {
    if (CART_SYNCING || !document.querySelector('#cart-table, form#cart')) return Promise.resolve(true);
    CART_SYNCING = true;
    return fetch(cartUrl('.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return Promise.all((cart.items || []).map(function (item) {
          return itemMinimum(item).then(function (minimum) {
            var row = document.getElementById('product-id-' + String(item.key));
            var input = row && row.querySelector('.item-qty');
            var visible = input ? toInteger(input.value, item.quantity) : item.quantity;
            if (row && minimum > 0) row.setAttribute('data-gm-cart-minimum', String(minimum));
            if (input && minimum > 0) {
              input.min = String(minimum);
              input.setAttribute('data-gm-cart-minimum', String(minimum));
            }
            return { key: item.key, quantity: visible, minimum: minimum };
          });
        }));
      })
      .then(function (rules) {
        var updates = {};
        rules.forEach(function (rule) {
          if (rule.minimum > 0 && rule.quantity > 0 && rule.quantity < rule.minimum) updates[rule.key] = rule.minimum;
        });
        if (!Object.keys(updates).length) return true;
        return fetch(cartUrl('/update.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          window.location.reload();
          return false;
        });
      })
      .catch(function (error) {
        console.error('Gummy Molds minimum quantity check:', error);
        return false;
      })
      .finally(function () { CART_SYNCING = false; });
  }

  function customPackageLabel(variant) {
    if (!variant || !variant.sku) return '';
    var sku = String(variant.sku).toUpperCase();
    if (sku.indexOf('CGM-') !== 0 && sku.indexOf('CCM-') !== 0) return '';
    var strings = copy();
    if (sku.indexOf('PROTOTYPE') !== -1) return sku.indexOf('CCM-') === 0 ? strings.prototypeChocolate : strings.prototypeGummy;
    var parts = sku.split('-');
    var quantity = parts[parts.length - 1];
    if (!/^\d+$/.test(quantity)) return '';
    return strings.packagePrefix + quantity + strings.packageSuffix;
  }

  function synchronizeCustomPackageButton(variant) {
    var button = document.querySelector('[data-custom-package-atc]');
    if (!button) return;
    var label = customPackageLabel(variant);
    if (!label) return;
    button.dataset.atc = label;
    button.textContent = label;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-quantity-increment], [data-quantity-decrement]');
    if (button) {
      setTimeout(function () {
        var selector = button.closest('[data-gm-mold-selector]');
        if (selector) applyProductState(selector.querySelector('[data-gm-mold-quantity]'), false, true);
      }, 0);
    }
    var checkout = event.target.closest && event.target.closest('[name="checkout"]');
    if (checkout) {
      event.preventDefault();
      synchronizeCart().then(function (valid) {
        if (!valid) return;
        var form = checkout.closest('form');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(checkout);
          return;
        }
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = checkout.name || 'checkout';
        hidden.value = checkout.value || 'Checkout';
        form.appendChild(hidden);
        form.submit();
      });
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('[data-gm-mold-quantity]')) applyProductState(event.target, false, false);
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-gm-mold-quantity]')) applyProductState(event.target, false, true);
    if (event.target.matches && event.target.matches('#cart-table .item-qty[data-gm-cart-minimum]')) {
      var minimum = toInteger(event.target.getAttribute('data-gm-cart-minimum'), 0);
      if (toInteger(event.target.value, 0) > 0 && toInteger(event.target.value, 0) < minimum) event.target.value = String(minimum);
    }
  }, true);

  window.addEventListener('product-variant-switch', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    setTimeout(function () {
      document.querySelectorAll('[data-gm-mold-quantity]').forEach(function (input) {
        applyProductState(input, true, true);
      });
      synchronizeCustomPackageButton(variant);
    }, 0);
  });

  document.addEventListener('cartItems', function () { setTimeout(synchronizeCart, 75); });

  function initialize() {
    document.querySelectorAll('[data-gm-mold-quantity]').forEach(function (input) {
      applyProductState(input, false, true);
    });
    synchronizeCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();